import { EThemeNames } from '@/constants';
import WarningIcon from '@/icons/WarningIcon';
import { EEventTypes } from '@/types';
import { EBotNamesBackend, IBotConfigType } from '@/types/botConfigTypes';

/**
 * UI config per bot, keyed by the backend bot name.
 *
 * The key is the same value space `getBotNameFromRoute` returns, so one
 * route→bot map serves both this and SessionProvider. There is no separate
 * frontend key: a third namespace only had to be kept in sync with the other
 * two.
 */
export const botConfigs: Record<EBotNamesBackend, IBotConfigType> = {
  [EBotNamesBackend.SPECIALITY_MATCH]: {
    homeScreen: {
      title: 'Hello {placeholder}',
      subtitle: "Let's find you a doctor",
      inputPlaceholder: 'Tell us the symptoms',
    },
    warning: {
      text: 'Whatever you share, stays here. Your privacy is in good hands.',
      icon: WarningIcon,
    },
    useCases: [
      {
        title: 'Find the support you need',
        info: 'A few gentle questions will help us understand your current state and match you with a therapist who can walk alongside you.',
        themeName: EThemeNames.MATCH_THERAPIST_DEFAULT,
        additionalInfo: {
          text: 'Whatever you share, stays here. Your privacy is in good hands.',
          icon: WarningIcon,
          type: EEventTypes.INFO,
        },
      },
    ],
    finalFeedbackText: 'Thanks for your feedback',
    botName: EBotNamesBackend.SPECIALITY_MATCH,
    themeName: EThemeNames.TELEHEALTH_TRIAGE_BOT,
  },
  /**
   * The standalone /match-therapist-v2 flow. Copy only — it shares the triage
   * theme, and has no `useCases`: that array belongs to the v1 therapist page,
   * which reaches this config through the `match-therapist` route.
   */
  [EBotNamesBackend.THERAPIST_MATCH]: {
    homeScreen: {
      title: "Let's match a therapist who gets you",
      subtitle: "Tell us what's on your mind. We'll take it from there.",
      inputPlaceholder: 'Start typing, in your own words…',
    },
    warning: {
      text: 'Whatever you share, stays here. Your privacy is in good hands.',
      icon: WarningIcon,
    },
    finalFeedbackText: 'Thanks for your feedback',
    botName: EBotNamesBackend.THERAPIST_MATCH,
    themeName: EThemeNames.TELEHEALTH_TRIAGE_BOT,
  },
};
